import { useCallback } from 'react';
import { Button } from '@packages/ui/primitives/Button';
import { useEventScope } from '@packages/block-events/react';
import { ActionRegistry } from '@packages/table-builder/registry';
import type { ButtonBlock } from '../types/blocks';

export interface ButtonBlockRendererProps {
  block: ButtonBlock;
}

export function ButtonBlockRenderer({ block }: ButtonBlockRendererProps): JSX.Element {
  const scope = useEventScope();

  const handleClick = useCallback(() => {
    if (scope) {
      scope.bus.publish('CUSTOM', block.semanticId ?? block.$id, {
        actionId: block.event,
        ...(block.eventPayload ?? {}),
      });
    }

    if (block.actionId) {
      ActionRegistry.executeAction(block.actionId, {
        params: block.eventPayload as Record<string, string> | undefined,
      });
    }
  }, [scope, block.semanticId, block.$id, block.event, block.eventPayload, block.actionId]);

  return (
    <Button
      variant={block.variant ?? 'secondary'}
      size={block.size ?? 'md'}
      label={block.label}
      icon={block.icon}
      trailingIcon={block.trailingIcon}
      disabled={block.disabled}
      onClick={handleClick}
      semanticId={block.semanticId}
    />
  );
}
